import { render } from "./splashScreen.vue?vue&type=template&id=8cb9b0ce&scoped=true"
import script from "./splashScreen.vue?vue&type=script&lang=js"
export * from "./splashScreen.vue?vue&type=script&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=8cb9b0ce&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb9b0ce"]])

export default __exports__